import { autoinject } from "aurelia-framework";
import { PartialInspectionLayoutModel, SubmmittedInspectionModel } from "../../../models/rightship-inspections.models";
import { TitleConst } from "../../../constants/title.constaints";
import { Router } from "aurelia-router";
import { RsInspectionRouteConstants } from "../../../constants/route.constants";

@autoinject
export class SubmittedChangeInspectionDate {

    public submmittedInspections: SubmmittedInspectionModel;
    public inspectionModel: PartialInspectionLayoutModel;
    public readonly title: string = TitleConst.ChangeInspectionDate;
    private _encryptedData: string;
    
    constructor(private router: Router) {
    }
        
    activate(params: { vesselName: string, 
        vesselImo: string, 
        portName: string, 
        country: string, 
        requestedInspectionDate: string, 
        previousInspectionDate: string, 
        encryptedData: string, 
        rsInspectionId: string,
        agentName: string,
        agentEmailAddress: string,
        agentOfficeNumber: string }) {
        this._encryptedData = params.encryptedData;
        this.submmittedInspections = {
            vesselName: params.vesselName,
            vesselImo: params.vesselImo,
            portName: params.portName,
            country: params.country,
            previousInspectionDate: params.previousInspectionDate,
            requestedInspectionDate: params.requestedInspectionDate,
            agentName: params.agentName,
            agentEmailAddress: params.agentEmailAddress,
            agentOfficeNumber: params.agentOfficeNumber
        }
        this.inspectionModel = {
            vesselDetails: {
                vesselName: params.vesselName,
                vesselImo: params.vesselImo,
            },
            portAndOperationalDetails: {
                port: params.portName,
                country: params.country,
                requestedInspectionDate: params.requestedInspectionDate
            },
            rightShipInspectionId: params.rsInspectionId,
            agentDetails: {
                agentName: params.agentName,
                agentEmailAddress: params.agentEmailAddress,
                agentOfficeNumber: params.agentOfficeNumber
            }

        }
    }
    
    //Return to inspection page
    close() {
        this.router.navigateToRoute(RsInspectionRouteConstants.Inspection, {
            encryptedData: this._encryptedData
        });
    }
}